import React from 'react';
import { withTranslation } from 'react-i18next';
import { ModalBody, ModalHeader  } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';

const Info = props => {
    return (
        <>
            <ModalHeader className="modal-popover" toggle={props.closeModal}></ModalHeader>
            <ModalBody>
                <p className="text-16 mb-0">
                    { props.message }
                </p>
            </ModalBody>
        </>
    )
}

export default withTranslation('translations')(modalWrapper(true, "InfoModal")(Info));